import { ActionType } from "../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../react-core/Flux/Dispatcher";
import { ExcelExportStatic } from "./ExcelExportStatic";


export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const ExcelExportDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ExcelExportStore: ExcelExportStatic = new ExcelExportStatic();
